import React from 'react';
import {checkNullStr} from "../../common/fusion-ui/utils/ReactUtils";
import {UrlPreview} from "../../common/fusion-ui";
import {useTheme} from "../../common/ProjectThemeProvider";

const AppLinkPreview = React.memo(({
                                       url,
                                       label = 'Link Preview',
                                   }) => {
    const TAG = "AppLinkPreview";
    const theme = useTheme();


    return (<>
            {checkNullStr(url) && <UrlPreview
                url={url}
                label={label}
                wrapperClassName={'w-100 bg-infox'}
                labelClassName={'fw-semi-bold'}
                className={'w-100 border-2 border-solid rounded-4'}
                labelStyle={{color: theme.text}}
                style={{borderColor: theme.text10}}
            />}
        </>
    )
});
export default AppLinkPreview;
